// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3BFDt","calendarButtons":"ClockData_calendarButtons__3ZkCd"};